import React from "react";

export const Loading = () => {
  return (
    <div className={"pageLoader"}>
      <img
        src={"/assets/images/logo_speeltuinchef.png"}
        alt={"Speeltuinchef wordt geladen"}
      />
      <p>Laden</p>
    </div>
  );
};
